import React, { Fragment, useEffect, useState } from 'react';
import {
  Typography,
  Button,
  Form,
  message,
  Select,
  Modal,
  Spin,
  Radio,
  Space,
} from 'antd';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { filterAccessibleSeasons } from '../../../utils/seasonFilter';

const { Option } = Select;
const { Title, Text } = Typography;

const MODEL_OPTIONS = [
  ['3x3x5', 'Aタイプ：AXLEモデル'],
  ['eleader', 'Aタイプ：Engaging Leaderモデル'],
  ['gates', 'Aタイプ：GATESモデル'],
  ['initiative', 'Aタイプ：Initiativeモデル'],
  ['6x6', 'Bタイプ：6×6'],
  ['6x5', 'Bタイプ：6×5'],
  ['5x6', 'Bタイプ：5×6'],
  ['cup', 'Bタイプ：cupモデル'],
];

const filterSeasonsByModel = (seasons, user, model) =>
  filterAccessibleSeasons(seasons, user, ['40010']).filter(
    (season) =>
      Array.isArray(season.question_set) &&
      season.question_set.some((questionSet) => questionSet.type_360 === model)
  );

// 360度診断(40010) 8モデルの回答集計Excelダウンロード。
// 集計・xlsx生成はサーバ(/api/dbModel100/excel40010)側で行う。
const Excel40010DownloadPage = () => {
  const [groups, setGroups] = useState([]);
  const [selGroupInfo, setSelGroupInfo] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState('');
  const [groupSurveySeasonInfo, setGroupSurveySeasonInfo] = useState([]);
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]);
  const [selSurveySeasonId, setSelSurveySeasonId] = useState('');
  const [surveyType, setSurveyType] = useState('3x3x5');
  const [submitSW, setSubmitSW] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      setUserInfo(usr.userData);

      const groupInfo = await Axios.get('/api/group/40010');
      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        setGroups(
          groupInfo.data.groups.filter((item) => item.group_code !== 'RECRNT')
        );
      } else {
        setGroups(groupInfo.data.groups);
      }

      if (usr.userData.role === 3) {
        const group = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );
        setSelGroupCode(usr.userData.groupCode);
        setSelGroupInfo(group);
        setGroupSurveySeasonInfo(
          filterSeasonsByModel(group.survey_season, usr.userData, surveyType)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
  }, [usr]);

  const onChangeGroup = (value) => {
    const group = groups.find((item) => item.group_code === value);
    setSelGroupCode(value);
    setSelGroupInfo(group);
    setGroupSurveySeasonInfo(
      filterSeasonsByModel(group.survey_season, usr.userData, surveyType)
    );
    setSelSurveySeasonId('');
    setSelSurveySeasonInfo([]);
  };

  const onChangeSurveyType = (event) => {
    const model = event.target.value;
    setSurveyType(model);
    if (selGroupInfo && selGroupInfo.survey_season) {
      setGroupSurveySeasonInfo(
        filterSeasonsByModel(selGroupInfo.survey_season, usr.userData, model)
      );
    }
    setSelSurveySeasonId('');
    setSelSurveySeasonInfo([]);
  };

  const onChangeSurveySeason = (value) => {
    setSelSurveySeasonId(value);
    setSelSurveySeasonInfo(
      groupSurveySeasonInfo.find((item) => item._id === value)
    );
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      message.loading({
        content: 'データ作成中...',
        key: 'makeexcel',
        duration: 60,
      });
      setIsModalVisible(true);
      setSubmitSW(false);

      const res = await Axios.post(
        '/api/dbModel100/excel40010',
        {
          group_code: selGroupCode,
          survey_season_id: selSurveySeasonId,
          type_360: surveyType,
        },
        { responseType: 'blob' }
      );

      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `Recurrent_40010_All_Result_List_${selGroupInfo.group_name}_${selSurveySeasonInfo.season_name}.xlsx`;
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);

      message.success({
        content: 'ダウンロード完了！',
        key: 'makeexcel',
        duration: 2,
      });
      setSubmitSW(true);
      setIsModalVisible(false);
    } catch (error) {
      console.log(error.message);
      setIsModalVisible(false);
      message.error({
        content: error.message,
        key: 'makeexcel',
        duration: 4,
      });
      setSubmitSW(true);
    }
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '1100px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>360度診断結果ダウンロード(EXCEL)</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>
            企業を選択してください。（必須）
          </Text>
          <Select
            showSearch
            style={{ marginLeft: 0, marginRight: 10, width: 300 }}
            placeholder="企業選択"
            optionFilterProp="children"
            onChange={onChangeGroup}
            value={selGroupCode}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            disabled={userInfo.role === 3}
          >
            {groups.map((group) => (
              <Option value={group.group_code} key={group._id}>
                {group.group_name}
              </Option>
            ))}
          </Select>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
          <Text strong>診断タイプを選択してください。（必須）</Text>
          <br />
          <br />
          <Radio.Group onChange={onChangeSurveyType} value={surveyType}>
            <Space direction="vertical">
              {MODEL_OPTIONS.map(([value, label]) => (
                <Radio value={value} key={value}>
                  {label}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>
            サーベイを選択してください。（必須）
          </Text>
          <Select
            showSearch
            style={{ marginLeft: 0, marginRight: 5, width: 400 }}
            placeholder="サーベイ選択"
            optionFilterProp="children"
            onChange={onChangeSurveySeason}
            value={selSurveySeasonId}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {groupSurveySeasonInfo.map((season) => (
              <Option value={season._id} key={season._id}>
                {season.season_name}
              </Option>
            ))}
          </Select>
          <Title style={{ color: 'var(--brand-primary)' }}>❹</Title>
          <Button
            type="default"
            className="ds-btn-secondary"
            size="large"
            onClick={onSubmit}
            disabled={!(submitSW && selSurveySeasonId && surveyType)}
          >
            集計データダウンロード（Excel）
          </Button>
        </Form>
      </div>
      <Modal
        title="結果作成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
};

export default Excel40010DownloadPage;
